export default __webpack_public_path__ + "static/media/code-overlay.60626676.png";